import React from "react";
import PropTypes from "prop-types";
import "./AdminCoursePreviewStudentSidebar.css";

const BASE_NAV_ITEMS = [
  { id: "campus", label: "Campus" },
  { id: "comunicados", label: "Comunicados", previewOnly: true },
  { id: "mensajes", label: "Mensajes", previewOnly: true },
];

function AdminCoursePreviewStudentSidebar({
  courseTitle,
  pestanas,
  activePestana,
  onPestanaChange,
}) {
  const handleNavClick = (itemId) => {
    if (itemId === "campus") {
      onPestanaChange(pestanas[0] ?? "");
      return;
    }
    if (pestanas.includes(itemId)) {
      onPestanaChange(itemId);
    }
  };

  return (
    <nav className="admin-preview-student-sidebar" aria-label="Navegación del curso (vista previa)">
      <h3 className="admin-preview-student-sidebar__title">
        {courseTitle || "Menú"}
      </h3>
      <ul className="admin-preview-student-sidebar__list">
        {BASE_NAV_ITEMS.map((item) => {
          const isActive = item.id === "campus"
            ? !activePestana || activePestana === pestanas[0]
            : false;
          return (
            <li key={item.id}>
              <button
                type="button"
                className={`admin-preview-student-sidebar__btn${isActive ? " active" : ""}${item.previewOnly ? " preview-only" : ""}`}
                onClick={() => handleNavClick(item.id)}
                disabled={item.previewOnly}
                title={item.previewOnly ? "Disponible en el campus del alumno" : undefined}
              >
                {item.label}
              </button>
            </li>
          );
        })}
        {pestanas.map((pestana) => (
          <li key={pestana}>
            <button
              type="button"
              className={`admin-preview-student-sidebar__btn${activePestana === pestana ? " active" : ""}`}
              onClick={() => onPestanaChange(pestana)}
            >
              {pestana}
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
}

AdminCoursePreviewStudentSidebar.propTypes = {
  courseTitle: PropTypes.string,
  pestanas: PropTypes.arrayOf(PropTypes.string),
  activePestana: PropTypes.string,
  onPestanaChange: PropTypes.func.isRequired,
};

AdminCoursePreviewStudentSidebar.defaultProps = {
  courseTitle: "",
  pestanas: [],
  activePestana: "",
};

export default AdminCoursePreviewStudentSidebar;
